module.exports = __webpack_public_path__ + "media/newstyle/images/chevron-right-1812e30b937b0ab0da572fc20172331d.svg";